import React from "react";
import Slider from "react-slick";
import brand1 from "../../image/brand1.webp";
import brand2 from "../../image/brand2.webp";
import brand3 from "../../image/brand3.webp";
import brand4 from "../../image/brand4.webp";
import brand5 from "../../image/brand5.webp";
import "../../css/services.css";

const brands = [brand1, brand2, brand3, brand4, brand5];

function Services() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 992);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 800,
    cssEase: "ease-in-out"
  };

  return (
    <section id="services" className="py-3 py-lg-5 bg-white">
      <div className="container text-center">
        {/* Section Header */}
        <div className="mb-5">
          <h6 className="fw-bold text-uppercase mb-2" style={{ color: '#e86229', letterSpacing: '2px' }}>
            Our Manufacturer
          </h6>
          <h2 className="fw-bold display-6" style={{ color: '#1a2f55' }}>
            Trusted Manufacturing Partner
          </h2>
          <div style={{ width: "60px", height: "4px", backgroundColor: "#e86229", margin: "15px auto", borderRadius: "2px" }}></div>
        </div>

        <div className="brand-slider-container px-3 px-md-5">
          <Slider {...sliderSettings}>
            {brands.map((logo, index) => (
              <div key={index} className="px-3 outline-none">
                <div className="brand-card d-flex justify-content-center align-items-center p-4 rounded shadow-sm border border-light bg-white" style={{ height: "120px" }}>
                  <img
                    src={logo}
                    alt={`Brand ${index + 1}`}
                    className="img-fluid"
                    style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain", filter: "grayscale(10%)", transition: "all 0.3s ease" }}
                    onMouseOver={e => e.currentTarget.style.filter = "grayscale(0%)"}
                    onMouseOut={e => e.currentTarget.style.filter = "grayscale(10%)"}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Services;
